import {deleteJSON, getJSON, paymentDelJSON, paymentGetJSON, paymentPostJSON, paymentPutJSON, postJSON, putJSON, reportGetJSON, shipdayGetJSON, realTimePost, shipdayPostJSON, aiPostJSON} from "./requests";
import {getAchInitReqUrl} from "./constructAPIReq";

export const findEnterpriseLoginInfo = async (data) => await postJSON('/auth/login', data);
export const findAccessToken = async (refreshToken) => await postJSON('/auth/refresh/' + refreshToken, {});
export const findEnterpriseDetails = async () => await getJSON('/admin/info');
export const updatePartnerPassword = async (data) => await paymentPutJSON('/payment/partners/details/update', data);
// this is the invoice API
export const findPartnerPayments = async () => await paymentGetJSON('/enterprise/invoices');
// Card info API
export const findPartnerPaymentsCard = async () => await paymentGetJSON('/enterprise/payment-info');
// Add Card API
export const addPartnerPaymentCard = async (data) => await paymentPutJSON('/enterprise/card', data);
export const createPartnerPaymentUser = async () => await paymentPostJSON('/payment/partners/users');
// update Card API
export const updatePartnerPaymentCard = async (data) => await paymentPutJSON('/enterprise/card', data);
// Remove Card API
export const removePartnerPaymentCard = async () => await paymentDelJSON('/enterprise/card');
export const updatePartnerBankInfo = async (data) => await paymentPutJSON('/payment/partners/payout-info', data);
export const addNewPartner = async (data) => await paymentPostJSON('/payment/partners/add', data);
export const findReferralLink = async () => await paymentGetJSON('/payment/partners/invitation-link');
// confusion
export const fetchACHBankInfo = async () => await paymentGetJSON('/enterprise/payment-info');
export const findMagicLink = async (data) => await postJSON('/auth/access/account', data, true);
export const initACH = async () =>  await paymentPostJSON(getAchInitReqUrl(), {});
export const setBillingInformation = async (data) => await putJSON('/invoice/recipient/info', data);
// notifications
export const findNotificationEmails = async () => await getJSON('/notification/emails');
export const updateNotificationEmails = async (data) => await putJSON('/notification/emails', data);
// review notification emails
export const findReviewNotificationEmails = async () => await getJSON('/notification/review');
export const updateReviewNotificationEmails = async (data) => await putJSON('/notification/review', data);
// report
export const fetchExtendedReport = async (startDate, endDate, timeFrame) => await reportGetJSON('/enterprise/extended/orders', {
    timeframe: timeFrame,
    startDate: startDate,
    endDate: endDate
});

export const fetchCompanyConfigurations = async () => await reportGetJSON('/enterprise/companies/configurations')

// summary
export const fetchCompanyReviewSummary = async (companyId) => await getJSON(`/analytics/review/summary/${companyId}/thisMonth`)
export const fetchCompanyAiInsights = async (companyId) => await getJSON(`/analytics/insights/actionable/${companyId}/this_month`)
export const fetchAllCompanyReviewSummary = async (startDate, endDate, timeframe) => await reportGetJSON('/enterprise/review/summary', {
    startDate: startDate,
    endDate: endDate,
    timeframe: timeframe
});

// ai
export const fetchReviewAiInsights = async (timeframe) => await reportGetJSON(`/enterprise/review/ai-insight/${timeframe}`);
export const fetchOperationalAiInsights = async () => await reportGetJSON(`/enterprise/operational/ai-insight`);

export const fetchReviewsList = async (timeframe) => await reportGetJSON(`/enterprise/review/list`, {
    timeframe: timeframe
});

// cards
export const fetchCards = async () => await getJSON('/stripe/cards');
export const addCard = async (data) => await postJSON('/stripe/cards', data, true);
export const deleteCard = async (cardId) => await deleteJSON(`/stripe/cards/${cardId}`);

// plans
export const fetchPlans = async () => await shipdayGetJSON('internal/billing/plans');

export const fetchCompaniesIdToken = async () => await getJSON('/admin/companies/signed');

//review respones
export const fetchReviewChatRooms = async (data) => await realTimePost("/review/enterprise/room/check", data);
export const postReviewInitiate = async (data) => await shipdayPostJSON("/chat/enterprise/review/initiate", data);
export const generateAiResponse = async (data) => await aiPostJSON("/review/response/enterprise/ask", data);
export const rewriteAiResponse = async (data) => await aiPostJSON("/review/response/enterprise/rewrite", data);

// users
export const fetchUsers = async () => await getJSON('/users');
export const updateUser = async (userId, data) => await putJSON(`/users/${userId}`, data);
export const updatePassword = async (data) => await putJSON('/admin/password', data);
